export const DOMAIN = String(import.meta.env.VITE_SHOPIFY_URL)
export const OATBIZ_HOST = import.meta.env.VITE_OATBIZ_API_HOST
export const REFERRAL_DISCOUNT_CENTS = Number(import.meta.env.VITE_REFERRAL_DISCOUNT_CENTS ?? 2000)
export const BUNDLE_COLLECTION_ID = String(import.meta.env.VITE_BUNDLER_COLLECTION_ID)
export const COFFEE_BUNDLE_COLLECTION_ID = String(import.meta.env.VITE_COFFEE_BUNDLE_COLLECTION_ID)

export const MAX_BLENDERBOTTLE_QUANTITY = 5
export const BLENDERBOTTLE_PRICE = 6

export const EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]+$/
export const BUNDLE_SKU = /^(SUB-)?CUSTOM/i
export const COFFEE_BUNDLE_SKU = /^(SUB-)?COFFEE/i
export const BUNDLE_ITEM_SKU = /^\d{2}-\d{3}$/

export const BUNDLE_FILTERS = [
  'all',
  'fruit-flavor',
  'caffeinated',
  'vegan',
  'whey-protein'
] as const

export const PURCHASE_PLANS = {
  'monthly': 'subscription',
  'single': 'onetime'
}

export const BOX_SIZES = [ 16, 24 ] as const
